import TestAutoSharePage from "../pages/Automation/TestAutoSharePage";
import TestErrorQuerySharePage from "../pages/Automation/TestErrorQuerySharePage";
import PeloQAgentLoginPage from "../pages/PeloQAgentLogin";

const ShareRoutes = [
    { path: '/share-auto-test', element: <TestAutoSharePage /> },
    { path: '/share-error-query', element: <TestErrorQuerySharePage /> },
    { path: '/login', element: <PeloQAgentLoginPage /> },
];

export default ShareRoutes;
